import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import RoundOverviewUtil from '../RoundOverview/RoundOverviewUtil';

interface JsonImportDialogProps {
    open: boolean;
    title: string;
    hint?: string;
    // Returns an error message to show, or null when the import was accepted.
    onImport: (text: string) => string | null;
    onClose: () => void;
}

const JsonImportDialog: React.FC<JsonImportDialogProps> = (props) => {
    const [text, setText] = useState<string>("");
    const [error, setError] = useState<string>("");

    const onClose = () => {
        setError("");
        props.onClose();
    };

    const onImport = () => {
        var message = props.onImport(text);
        if (message) {
            setError(message);
            return;
        }
        setText("");
        onClose();
    };

    return (
        <Dialog open={props.open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent dividers>
                {props.hint ? (<Box fontSize={12} paddingBottom={1}>{props.hint}</Box>) : null}
                <TextField
                    value={text}
                    multiline
                    fullWidth
                    rows={20}
                    variant="outlined"
                    placeholder="Paste JSON here"
                    InputProps={{ style: { fontFamily: "monospace", fontSize: 12 } }}
                    onChange={e => { setText(e.target.value); setError(""); }}
                />
                {error.length > 0 ? (<Box color={RoundOverviewUtil.INVALID_COLOR} fontSize={12} paddingTop={1}>{error}</Box>) : null}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose()} color="primary">Cancel</Button>
                <Button onClick={() => onImport()} color="secondary" variant="contained" disabled={text.trim().length === 0}>
                    Import
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default JsonImportDialog;
